import React from 'react';

const Lock = ({ color = 'white' }) => (
  <svg
    width="19"
    height="21"
    viewBox="0 0 19 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.5 7H17.5C17.7652 7 18.0196 7.10536 18.2071 7.29289C18.3946 7.48043 18.5 7.73478 18.5 8V20C18.5 20.2652 18.3946 20.5196 18.2071 20.7071C18.0196 20.8946 17.7652 21 17.5 21H1.5C1.23478 21 0.98043 20.8946 0.792893 20.7071C0.605357 20.5196 0.5 20.2652 0.5 20V8C0.5 7.73478 0.605357 7.48043 0.792893 7.29289C0.98043 7.10536 1.23478 7 1.5 7H3.5V6C3.5 4.4087 4.13214 2.88258 5.25736 1.75736C6.38258 0.632141 7.9087 0 9.5 0C11.0913 0 12.6174 0.632141 13.7426 1.75736C14.8679 2.88258 15.5 4.4087 15.5 6V7ZM13.5 7V6C13.5 4.93913 13.0786 3.92172 12.3284 3.17157C11.5783 2.42143 10.5609 2 9.5 2C8.43913 2 7.42172 2.42143 6.67157 3.17157C5.92143 3.92172 5.5 4.93913 5.5 6V7H13.5ZM8.5 13V15H10.5V13H8.5ZM4.5 13V15H6.5V13H4.5ZM12.5 13V15H14.5V13H12.5Z"
      fill={color}
    />
  </svg>
);

export default Lock;
